import CompanyService from "@/store/services/company.service.js"
import CompanyOwnerService from "@/store/services/companyowner.service"
import UserInviteService from "@/store/services/userinvite.service"

export default {
  namespaced: true,
  state: {
    connectionsPerUser: [],
    connectionsPerCompany: [],
    invitationsPerUser: [],
    numberOfInactiveConnections: 0,
    availableCompanies: []
  },
  getters: {
    getConnectionsPerUser: state => state.connectionsPerUser.filter(connection => connection.isMyConnection === true),
    getConnectionsPerCompany: state => state.connectionsPerCompany,
    getInvitationsPerUser: state => state.invitationsPerUser,
    getNumberOfInactiveConnections: state => state.numberOfInactiveConnections,
    
    getActiveTeamMembers: (state, getters, rootState, rootGetters) => {
      const active_members = state.connectionsPerUser
      .filter(connection => connection.isMyConnection === true)
      .filter(member => { // current user will always be active
        return (member.id === rootGetters['main/getCurrentUser'].id) || (member.numberOfInactiveConnections < member.connections.filter(mem_conn => !mem_conn.rights.admin).length)
      }) // connections not on owned companies

      // reorder array to put current user as first item
      const currentUserIndex = active_members.findIndex(member => member.id === rootGetters['main/getCurrentUser'].id)
      if (currentUserIndex !== -1) {
        const myUser = active_members[currentUserIndex]
        active_members.splice(currentUserIndex, 1)
        active_members.unshift(myUser)
      }
      return active_members
    },

    getInactiveTeamMembers: (state, getters, rootState, rootGetters) => state.connectionsPerUser
      .filter(connection => connection.isMyConnection === true)
      .filter(member => { // excluding current user
        return (member.id !== rootGetters['main/getCurrentUser'].id) && (member.numberOfInactiveConnections >= member.connections.filter(mem_conn => !mem_conn.rights.admin).length)
      }),

    getOtherTeamMembers: state => state.connectionsPerUser.filter(connection => connection.isMyConnection !== true),
    getAvailableCompanies: state => state.availableCompanies,
    getMyOwnCompanies: state => state.availableCompanies.filter(company => company.is_owner === true)
  },
  mutations: {
    SET_CONNECTIONS_PER_USER (state, data) {
      state.connectionsPerUser = data
    },
    SET_INVITATIONS_PER_USER (state, data) {
      state.invitationsPerUser = data
    },
    SET_CONNECTIONS_PER_COMPANY (state, data) {
      state.connectionsPerCompany = data
    },
    SET_NUM_INACTIVE_CONNECTIONS (state, data) {
      state.numberOfInactiveConnections = data
    },
    SET_AVAILABLE_COMPANIES (state, data) {
      state.availableCompanies = data
    },
  },
  actions: {
    loadTeamMainData ({ dispatch }) {
      return Promise.all([
        dispatch('loadCompanyOwner'),
        dispatch('loadAvailableCompanies')
      ])
    },
    loadAvailableCompanies ({ commit }) {
      return CompanyService.list().then((response) => {
        commit('SET_AVAILABLE_COMPANIES', response.data)
      })
    },
    loadCompanyOwner ({ commit, rootGetters }) {
      return CompanyOwnerService.list({
        extended: 'True',
      }).then((response) => {
        const current_user_id = rootGetters['main/getCurrentUser'].id

        const connectionsPerUser = []
        const connectionsPerCompany = {}
        let numberOfInactiveConnections = 0

        const companyData = response.data

        const myCompanyIds = []
        companyData.forEach(item => {
          if (item.user.id === current_user_id && item.rights.admin) {
            myCompanyIds.push(item.company_profile.id)
          }
        })

        companyData.forEach(item => {
          item.isMyConnection = false

          if (myCompanyIds.indexOf(item.company_profile.id) != -1) {
            item.isMyConnection = true
            if (!item.is_active) {
              this.numberOfInactiveConnections++
            }
          }
          
          // By company aggregation
          if (!Object.prototype.hasOwnProperty.call(connectionsPerCompany, item.company_profile.id)) {
          // if (!Object.hasOwn(connectionsPerCompany, item.company_profile.id)) {
            connectionsPerCompany[item.company_profile.id] = JSON.parse(JSON.stringify(item))
            connectionsPerCompany[item.company_profile.id].connections = []
            connectionsPerCompany[item.company_profile.id].connections.push(JSON.parse(JSON.stringify(item)))
          } else {
            if (!connectionsPerCompany[item.company_profile.id].connections) {
              connectionsPerCompany[item.company_profile.id].connections = []
            }
            connectionsPerCompany[item.company_profile.id].connections.push(JSON.parse(JSON.stringify(item)))
            if (item.user.id === current_user_id) {
              item.connections = connectionsPerCompany[item.company_profile.id].connections
              connectionsPerCompany[item.company_profile.id] = JSON.parse(JSON.stringify(item))
            }
          }

          const connIndex = connectionsPerUser.findIndex(user => user?.id === item.user.id)
          if (connIndex > -1) { // exists
            connectionsPerUser[connIndex].connections.push(JSON.parse(JSON.stringify(item)))
            if (item.isMyConnection) {
              connectionsPerUser[connIndex].isMyConnection = item.isMyConnection
            }
            if (!item.is_active) {
              connectionsPerUser[connIndex].numberOfInactiveConnections++
            }
          } else {
            let connUserObj = item.user
            connUserObj.isMyConnection = item.isMyConnection
            connUserObj.numberOfInactiveConnections = 0
            if (!item.is_active) {
              connUserObj.numberOfInactiveConnections++
            }
            connUserObj.connections = []
            connUserObj.connections.push(JSON.parse(JSON.stringify(item)))
            connectionsPerUser.push(connUserObj)
          }
        })
        commit('SET_CONNECTIONS_PER_USER', connectionsPerUser)
        commit('SET_CONNECTIONS_PER_COMPANY', connectionsPerCompany)
        commit('SET_NUM_INACTIVE_CONNECTIONS', numberOfInactiveConnections)
      }).then(() => {
        UserInviteService.list({
          extended: 'True',
          status: 'sent'
        }).then((response) => {
          const userInvites = response.data
          const invitationsPerUser = []

          userInvites.forEach(invite => {
            if (!invitationsPerUser.some(user => user?.id === invite.id)) {
              invitationsPerUser.push(invite)
            }
          })
          commit('SET_INVITATIONS_PER_USER', invitationsPerUser)
        });
      })

    },
  }
};
